module.exports = __webpack_public_path__ + "static/img/nav6.f66354f5.svg";